import _ from 'lodash';
import { AnyAction, Dispatch } from 'redux';
import { AddressFields } from '../../models/form-models';
import { ApiStatuses, YesNoIndicators } from '../../../../global/models/api-model';
import { CpgUserTypes, PersonalInfoActionTypes, PersonalInfoAppState, PersonalInfoState } from './personal-info-models';
import { DemographicAppKeys } from '../../../../global/models/demographics-model';

export const InitialState: PersonalInfoState = {
	currentPerson: null,
	setPersonFailed: false,
	loggedInAsAdmin: false,
	showPublishedAddressUpdate: false,
	pendingUpdateObject: null,
	newMailingAddress: null,
	patchPersonStatus: ApiStatuses.None,
	annualEnrollmentStatus: null,
	setAnnualEnrollmentStatusFailed: false,
};

export const InitialAppState: PersonalInfoAppState = {
	[DemographicAppKeys.myCPG]: InitialState,
	[DemographicAppKeys.arc]: InitialState,
};

export const personalInfoReducerByApp = (state = InitialAppState, action: AnyAction): PersonalInfoAppState => {
	const { app } = action;

	switch (action.type) {
		case PersonalInfoActionTypes.SET_PERSON_INFO:
			return {
				...state,
				[app]: {
					...state[app],
					currentPerson: action.payload,
					setPersonFailed: false,
				},
			};
		case PersonalInfoActionTypes.SET_PERSON_FAIL:
			return {
				...state,
				[app]: {
					...state[app],
					setPersonFailed: action.payload,
				},
			};
		case PersonalInfoActionTypes.SET_ADMIN:
			return {
				...state,
				[app]: {
					...state[app],
					loggedInAsAdmin: action.payload,
				},
			};
		case PersonalInfoActionTypes.FAKE_CLERGY:
			return {
				...state,
				[app]: {
					...state[app],
					currentPerson: { ...state[app].currentPerson, cleric_in_book: action.payload },
				},
			};
		case PersonalInfoActionTypes.PATCH_PERSON_STATUS:
			return {
				...state,
				[app]: {
					...state[app],
					patchPersonStatus: action.payload,
				},
			};

		case PersonalInfoActionTypes.TOGGLE_PUBLISHED_ADDRESS:
			return {
				...state,
				[app]: {
					...state[app],
					showPublishedAddressUpdate: action.payload.toggle,
					pendingUpdateObject: action.payload.pendingUpdate,
					newMailingAddress: action.payload.addressToupdate,
				},
			};
		case PersonalInfoActionTypes.UNLOAD_PERSON_STATE:
			return {
				...state,
				[app]: {
					currentPerson: null,
					setPersonFailed: false,
					loggedInAsAdmin: false,
					showPublishedAddressUpdate: false,
					pendingUpdateObject: null,
					newMailingAddress: null,
					patchPersonStatus: ApiStatuses.None,
				},
			};
		case PersonalInfoActionTypes.SET_ANNUAL_ENROLLMENT_STATUS:
			return {
				...state,
				[app]: {
					...state[app],
					annualEnrollmentStatus: action.payload,
					setAnnualEnrollmentStatusFailed: false,
				},
			};
		case PersonalInfoActionTypes.SET_ANNUAL_ENROLLMENT_STATUS_FAIL:
			return {
				...state,
				[app]: {
					...state[app],
					setAnnualEnrollmentStatusFailed: action.payload,
				},
			};
		default: return state;
	}
};

const processPersonData = (data) => {
	const copy = _.cloneDeep(data);
	copy.designation_salutation = `${copy.designation || copy.salutation}|${copy.salutation}`;
	return copy;
};

export const setCurrentPerson = (response, app: string) => {
	return {
		type: PersonalInfoActionTypes.SET_PERSON_INFO,
		payload: processPersonData(response.data),
		app,
	};
};

export const setPersonFailed = (error: boolean, app: string) => {
	return {
		type: PersonalInfoActionTypes.SET_PERSON_FAIL,
		payload: error,
		app,
	};
};

export const dispatchSetCurrentPerson = (dispatch: Dispatch<any>, app: string) => (response) => {

	dispatch(setCurrentPerson(response, app));

	if (app === DemographicAppKeys.myCPG) {
		//need to update this in the future to check retired
		document.cookie = `CPGUSERSTATUS=${response?.data?.is_clergy === YesNoIndicators.Yes ? CpgUserTypes.ACTIVE_CLERGY : CpgUserTypes.ACTIVE_LAY}; path=/`;
	}
};

export const dispatchSetCurrentPersonFailed = (dispatch: Dispatch<any>, app: string) => (error: boolean) => {
	dispatch(setPersonFailed(error, app));
};

export const setAdmin = (admin: boolean, app: string) => {
	return {
		type: PersonalInfoActionTypes.SET_ADMIN,
		payload: admin,
		app,
	};
};

export const fakeClergy = (ind: string, app: string) => {
	return {
		type: PersonalInfoActionTypes.FAKE_CLERGY,
		payload: ind,
		app,
	};
};

export const togglePublishedAddress = (toggle: boolean, addressToupdate: AddressFields, pendingUpdate: any, app: string) => {
	return {
		type: PersonalInfoActionTypes.TOGGLE_PUBLISHED_ADDRESS,
		payload: {
			toggle,
			addressToupdate,
			pendingUpdate,
		},
		app,
	};
};
export const setPatchPersonStatus = (status: ApiStatuses, app: string) => {
	return {
		type: PersonalInfoActionTypes.PATCH_PERSON_STATUS,
		payload: status,
		app,
	};
};

export const unloadPersonState = (app: string) => {
	return {
		type: PersonalInfoActionTypes.UNLOAD_PERSON_STATE,
		app,
	};
};

export const setAnnualEnrollmentStatus = (response, app: string) => {
	return {
		type: PersonalInfoActionTypes.SET_ANNUAL_ENROLLMENT_STATUS,
		payload: response,
		app,
	};
};

export const dispatchSetAnnualEnrollmentStatus = (dispatch: Dispatch<any>, app: string) => (response) => {
	dispatch(setAnnualEnrollmentStatus(response, app));
};

export const setAnnualEnrollmentStatusFailed = (error: boolean, app: string) => {
	return {
		type: PersonalInfoActionTypes.SET_ANNUAL_ENROLLMENT_STATUS_FAIL,
		payload: error,
		app,
	};
};

export const dispatchSetAnnualEnrollmentStatusFailed = (dispatch: Dispatch<any>, app: string) => (error: boolean) => {
	dispatch(setAnnualEnrollmentStatusFailed(error, app));
};
